interface ActivityItem {
    title: string;
    description: string;
    status: "success" | "warning" | "info";
}

interface ActivityPanelProps {
    accent: string;
    title: string;
    items: ActivityItem[];
}

export function ActivityPanel({
    title,
    items,
    accent,
}: ActivityPanelProps) {
    const colors = {
        success: "#10B981",
        warning: "#F59E0B",
        info: accent,
    };

    return (
        <div className="rounded-2xl border border-border bg-card p-3">
            <h3 className="text-sm font-semibold">
                {title}
            </h3>

            <div className="mt-5 space-y-3">
                {items.map((item) => (
                    <div
                        key={item.title}
                        className="flex gap-4"
                    >
                        <span
                            className="mt-1 inline-block h-2.5 w-2.5 flex-shrink-0 rounded-full"
                            style={{
                                background:
                                    colors[item.status],
                            }}
                        />

                        <div>
                            <h4 className="text-sm font-semibold">
                                {item.title}
                            </h4>

                            <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                                {item.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}